import { observer } from 'mobx-react-lite'
import { type MessageFieldStore } from 'widgets/MessageField/store/messageFieldStore'
import { MessageFieldContext } from 'widgets/MessageField/context/MessageFieldContext'
import {
  type IMessageFieldContentProps,
  MessageFieldContent,
} from 'widgets/MessageField/ui/MessageFieldContent'

export type IMessageFieldProps = IMessageFieldContentProps & {
  messageFieldStore: MessageFieldStore
  onDragHandler?: (condition: boolean) => void
  inboxId?: number
}

export const MessageField = observer(({ messageFieldStore, ...props }: IMessageFieldProps) => {
  return (
    <MessageFieldContext.Provider value={messageFieldStore}>
      <MessageFieldContent {...props} />
    </MessageFieldContext.Provider>
  )
})
